module.exports = __webpack_public_path__ + "img/结算台1.f6f05d31.png";